<template>
  <div class="main-box">
    <p class="title-crumb" @click="go()">
      <i class="el-icon-back"></i>
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>预警统计</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="box-content">
      <div class="head">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          @change="dofile"
        >
        </el-date-picker>
        <div></div>
        <div>设备号{{ deviceId }}</div>
      </div>
      <div class="content1">
        <div style="width: 10%; height: 100%">
          <ul class="ulhead">
            <li  class="listy" v-for="(item, index) in listTh" :key="index" >{{ item }}</li>
          </ul>
        </div>
        <div style="width: 90%; height: 100%">
          <ul class="ulhead ulhead2">
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;" >             
             <span  v-for="(item, index) in weightList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in hightList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in windspeedList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in radiusList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in lijupercentList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in angleList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in pengzhuangList" :key="index" :class="{ color: item != '--' }">{{item}}</span>  
            </li>
            <li class="listy "  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in createDateList" :key="index" >{{item}}</span>
            </li>

          </ul>
        </div>
        <span style="height: 30px;position: absolute;  bottom: 0;right: 20px;">单位(小时)</span>
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      deviceId: '',
      groupId: '',
      time:util.myTime.getCurTime(),
      // time: '2020-11-09',
      listTh: [
        '吊重(吨)',
        '高度(米)',
        '风速(米/每秒)',
        '力矩(米)',
        '幅度(°)',
        '回转(°)',
        '碰撞(次)',
        '',
      ],
      tableData: [],
      weightList:[],
      hightList:[],
      radiusList:[],
      angleList:[],
      lijupercentList:[],
      createDateList:[],
      pengzhuangList:[],
      windspeedList:[]
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.deviceId = this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      myHttp
        .select12Record({
          deviceId: this.deviceId,
          projectId: this.groupId,
          time: this.time,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            var list = resp.data.data.list || []
            var weightList = []
            var hightList=[]
            var angleList =[]
            var radiusList = []
            var lijupercentList = []
            var createDateList = []
            var pengzhuangList =[]
            var windspeedList =[]
            for(var i = 0;i<list.length;i++){       
               list[i].time=  list[i].time.split(' ')[1]
               weightList.push(list[i].loadweightr)
               hightList.push(list[i].hight)   
               angleList.push(list[i].angle)   
               radiusList.push(list[i].radius)
               lijupercentList.push(list[i].lijupercent)
               createDateList.push(list[i].time)
               pengzhuangList.push(list[i].pengzhuang)
               windspeedList.push(list[i].windspeed)
            }
            that.weightList =that.isData(weightList) 
            that.hightList = that.isData(hightList)
            that.radiusList =that.isData(radiusList) 
            that.angleList =that.isData(angleList) 
            that.lijupercentList = that.isData(lijupercentList)
            that.pengzhuangList = that.isData(pengzhuangList)
            that.windspeedList = that.isData(windspeedList)
            that.createDateList = createDateList
            console.log(that.weightList)
          }
        })
    },
    isData(arr){
      for(var i = 0;i<arr.length;i++){
         arr[i]=arr[i]>0?arr[i]:'--'
      }
     return arr
    },
    go() {
      this.$router.go(-1)
    },
    dofile(){
     this.getData()
    }
  },
}
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1vw;
}
.box-content {
  width: 100%;
  height: calc(100% - 5vh);
  background: #fff;
}
.head {
  display: flex;
  height: 6vh;
  padding: 1vh;
  align-items: center;
  justify-content: space-between;
}
.content1 {
  display: flex;
  height: calc(100% - 7vh);
}
.ulhead {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.ulhead2 {
  display: flex;
}
.listy{
 height: 40px;
 padding: 1vh;

}
.colorBg{
 background: #f4f7fc;
}
.color{
 color: #f00;
}
</style>